module.exports = __webpack_public_path__ + "img/wzf_16.6f287fa4.png";